'use es6';

export const IconMap = {
  canvaslink: 'link',
  canvasimage: 'insertImage',
  canvasemoji: 'emoji',
  canvassnippet: 'textSnippet',
  canvascta: 'ctas',
  canvasembed: 'embed',
  canvasvideo: 'insertVideo',
  canvastable: 'table',
  canvascallout: 'spacer',
  canvasanchor: 'anchor',
  canvascharmap: 'specialCharacter',
  canvasmore: 'readMore',
  canvashr: 'horizontalRule',
  canvasnonbreaking: 'nonbreakingSpace',
  canvasrsstokens: 'socialRss',
  canvasicon: 'logo',
  canvascontentgeneration: 'artificialIntelligence'
};
export const SHOW_TOOLBAR_SHEPHERD = 'SHOW_TOOLBAR_SHEPHERD';
export const TOGGLE_MENU_ITEM_DISABLED_STATE_EVENT_NAME = 'toggleMenuItemDisabledState';